import { Routes } from '@angular/router';

import { ButtonsComponent } from './buttons/buttons.component';
import { GridComponent } from './grid/grid.component';
import { ListsComponent } from './lists/lists.component';
import { MenuComponent } from './menu/menu.component';
import { TabsComponent } from './tabs/tabs.component';
import { StepperComponent } from './stepper/stepper.component';
import { ExpansionComponent } from './expansion/expansion.component';
import { ChipsComponent } from './chips/chips.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ProgressSnipperComponent } from './progress-snipper/progress-snipper.component';
import { ProgressComponent } from './progress/progress.component';
import { DialogComponent } from './dialog/dialog.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { SliderComponent } from './slider/slider.component';
import { SlideToggleComponent } from './slide-toggle/slide-toggle.component';
import { ProfileComponent } from './profile/profile.component';
import { UserComponent } from './user/user.component';
import { CutiComponent } from './cuti/cuti.component';
import { NotificationComponent } from './notification/notification.component';
import { RegulasiComponent } from './regulasi/regulasi.component';
import { MainProfileComponent } from './main-profile/main-profile.component';
import { FormasiComponent } from './formasi/formasi.component';
import { AlarmPegawaiComponent } from './alarm-pegawai/alarm-pegawai.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { RiwayatProfileComponent } from './riwayat-profile/riwayat-profile.component';
import { RiwayatProgressComponent } from './riwayat-progress/riwayat-progress.component';

export const MaterialRoutes: Routes = [
  {
    path: 'button',
    component: ButtonsComponent
  },
  {
    path: 'grid',
    component: GridComponent
  },
  {
    path: 'lists',
    component: ListsComponent
  },
  {
    path: 'menu',
    component: MenuComponent
  },
  {
    path: 'tabs',
    component: TabsComponent
  },
  {
    path: 'stepper',
    component: StepperComponent
  },
  {
    path: 'expansion',
    component: ExpansionComponent
  },
  {
    path: 'chips',
    component: ChipsComponent
  },
  {
    path: 'toolbar',
    component: ToolbarComponent
  },
  {
    path: 'progress-snipper',
    component: ProgressSnipperComponent
  },
  {
    path: 'progress',
    component: ProgressComponent
  },
  {
    path: 'dialog',
    component: DialogComponent
  },
  {
    path: 'tooltip',
    component: TooltipComponent
  },
  {
    path: 'snackbar',
    component: SnackbarComponent
  },
  {
    path: 'slider',
    component: SliderComponent
  },
  {
    path: 'slide-toggle',
    component: SlideToggleComponent
  },
  {
    path: 'profile/:profileId',
    component: ProfileComponent
  },
  {
    path: 'user',
    component: UserComponent
  },
  { path: 'cuti', component: CutiComponent },
  { path: 'cuti/:path', component: CutiComponent },
  {
    path: 'notification',
    component: NotificationComponent
  },
  {
    path: 'regulasi',
    component: RegulasiComponent
  },
  {
    path: 'profile-menu/:profileId',
    component: MainProfileComponent,
  },
  {
    path: 'riwayat/:profileId/:type',
    component: RiwayatProfileComponent,
  },
  {
    path: 'formasi',
    component: FormasiComponent
  },
  {
    path: 'alarm-pegawai',
    component: AlarmPegawaiComponent
  },
  {
    path: 'riwayat-progress/:progressId',
    component: RiwayatProgressComponent,
  },
  {
    path: '404',
    component: NotFoundComponent
  },
];
